{
  "team.description": "Everyone in the brokerage, their workload and results, and what each role may do.",
  "team.search": "Search people…",
  "team.tab.people": "People",
  "team.tab.roles": "Roles",
  "team.col.person": "Person",
  "team.col.role": "Role",
  "team.col.deals": "Deals",
  "team.col.lastSeen": "Last seen",
  "team.changeRole": "Change {name}'s role",
  "team.roleChanged": "Role updated.",
  "team.add": "Add person",
  "team.addBody": "They sign in with this email and the password you set, and can change it later.",
  "team.added": "{name} can now sign in.",
  "team.off": "Off",
  "team.col.team": "Team",
  "team.col.openLeads": "Open leads",
  "team.col.allLeads": "All leads",
  "team.changeTeam": "Change {name}'s team",
  "team.teamChanged": "{name} moved. Their leads went with them.",
  "team.noTeam": "No team",
  "team.leadsTeam": "Leads a team",
  "team.deactivate.title": "Turn off {name}'s account",
  "team.deactivate.body": "They can't sign in from now on and get no new leads. Nothing is deleted: their comments, calls and closed deals keep their name. {count, plural, =0 {They have no open leads.} one {Their open lead goes to the person you pick.} other {Their # open leads go to the people you pick.}}",
  "team.deactivate.who": "{count, plural, one {Who takes their open lead?} other {Who takes their # open leads?}}",
  "team.deactivate.shareHint": "Pick several people to share them evenly. Each lead keeps its status and its timer restarts.",
  "team.deactivate.pickFirst": "Pick who takes their leads first.",
  "team.deactivate.confirm": "Turn off",
  "team.deactivate.pending": "Turning off…",
  "team.deactivate.done": "{name} is turned off. {count, plural, =0 {No leads to move.} one {# lead moved.} other {# leads moved.}}",
  "team.reactivate.action": "Turn on",
  "team.reactivate.title": "Turn {name}'s account back on?",
  "team.reactivate.body": "They can sign in again with their old password and see their history. Leads that moved on stay with their new owners.",
  "team.reactivate.done": "{name} can sign in again.",
  "team.field.firstname": "First name",
  "team.field.lastname": "Last name",
  "team.field.birthdate": "Date of birth",
  "team.field.leader": "Team leader",
  "team.field.pickLeader": "Choose their leader",
  "team.field.picture": "Photo",
  "team.roles.count": "{count, plural, one {# permission} other {# permissions}}",
  "team.roles.new": "New role",
  "team.roles.edit": "Edit {name}",
  "team.roles.name": "Role name",
  "team.roles.systemHint": "Built-in roles keep their name; their permissions can change.",
  "team.roles.all": "Select all",
  "team.roles.none": "Clear",
  "team.roles.saved": "Role saved.",
  "team.roles.adminNote": "Admins always hold every permission.",
  "team.roles.delete": "Delete the {name} role?",
  "team.roles.deleteBody": "People with this role lose its permissions.",
  "team.roles.deleted": "Role deleted.",

  "tips.description": "Your team's playbook: short, practical advice for calls, viewings and closing.",
  "tips.search": "Search tips…",
  "tips.new": "New tip",
  "tips.edit": "Edit tip",
  "tips.body": "Tip",
  "tips.read": "Read",
  "tips.saved": "Tip saved.",
  "tips.delete": "Delete “{title}”?",
  "tips.deleteBody": "It disappears for the whole team.",
  "tips.deleted": "Tip deleted.",
  "tips.empty.title": "No tips yet",
  "tips.empty.body": "Share what works: an opening line, an objection answered, a closing habit.",

  "profile.tab.overview": "Overview",
  "profile.tab.settings": "Settings",
  "profile.details": "Your details",
  "profile.password": "Password",
  "profile.passwordCaption": "Enter your current password to set a new one.",
  "profile.currentPassword": "Current password",
  "profile.updatePassword": "Update password",
  "profile.passwordChanged": "Password updated.",
  "profile.upcoming": "Coming up",

  "catalog.description": "Developers and their projects. Every unit is filed under one of them.",
  "catalog.newDeveloper": "New developer",
  "catalog.editDeveloper": "Edit developer",
  "catalog.newProject": "New project",
  "catalog.editProject": "Edit project",
  "catalog.name": "Name",
  "catalog.logo": "Logo",
  "catalog.image": "Image",
  "catalog.imageRequired": "Required. JPG, PNG or WebP.",
  "catalog.imageOptional": "Optional. Leave empty to keep the current one.",
  "catalog.projectsCount": "{count, plural, =0 {No projects yet} one {# project} other {# projects}}",
  "catalog.empty.title": "No developers yet",
  "catalog.empty.body": "Add the developers you sell for, then their projects, before adding units.",

  "setup.color": "Colour",
  "setup.colorOf": "Colour of {name}",
  "setup.saved": "Saved.",
  "setup.system": "Built-in",
  "setup.moveUp": "Move {name} up",
  "setup.moveDown": "Move {name} down",
  "setup.rename": "Rename {name}",
  "setup.delete": "Delete {name}",
  "setup.deleteTitle": "Delete {name}?",
  "setup.deleted": "Deleted.",
  "setup.notInUse": "Not in use",

  "statuses.description": "The journey a lead moves through. Each status has a colour (its column on the board) and a time limit: when it runs out in working hours, the lead rotates to the next agent.",
  "statuses.placeholder": "New status, e.g. Viewing booked",
  "statuses.orderHint": "This order is the order of the board's columns. Time limits count working hours and working days only (Setup › Working hours).",
  "statuses.added": "{name} added. It's now a column on the board.",
  "statuses.empty": "No statuses yet",
  "statuses.systemHint": "Built in: new leads, rotation, reservations or the Cold calls pool rely on it. Rename, recolour, time and move it; it can't be deleted.",
  "statuses.limit.amount": "Time limit for {name}",
  "statuses.limit.unit": "Time limit unit for {name}",
  "statuses.limit.hours": "Hours",
  "statuses.limit.days": "Days",
  "statuses.limit.none": "No limit",
  "statuses.limit.saved": "Time limit for {name} saved.",
  "statuses.inUseHint": "Records are on this status. Move them to another status before deleting it.",
  "statuses.deleteBody": "Nobody is on it now. It leaves the board and every status menu.",
  "statuses.usage.leads": "{count, plural, one {# lead} other {# leads}}",
  "statuses.usage.coldCalls": "{count, plural, one {# cold call} other {# cold calls}}",
  "statuses.usage.farming": "{count, plural, one {# owner} other {# owners}}",

  "stages.description": "The steps a deal moves through, from first contact to won or lost. Add your own, colour them and put them in order.",
  "stages.placeholder": "New stage, e.g. Viewing, Negotiation, Reservation",
  "stages.orderHint": "This order is the order of the pipeline board's columns.",
  "stages.added": "{name} added. It's now a column on the pipeline.",
  "stages.empty": "No stages yet",
  "stages.systemHint": "Built in: new deals start at New, and the results count Closed-Won and Closed-Lost. It can be recoloured and moved, not renamed or deleted.",
  "stages.inUseHint": "Deals are on this stage. Move them to another stage before deleting it.",
  "stages.deleteBody": "No deal is on it now. It leaves the pipeline board.",
  "stages.usage": "{count, plural, one {# deal} other {# deals}}",

  "unitTags.description": "The labels you market units with: Hot, Sea view, Ready to move. A unit carries one at a time.",
  "unitTags.placeholder": "New tag, e.g. Sea view",
  "unitTags.orderHint": "This order is the order of the tag menu and the tag filter.",
  "unitTags.added": "{name} added. Pick it from any unit's tag menu.",
  "unitTags.empty": "No tags yet",
  "unitTags.deleteBody": "No unit carries it now.",
  "unitTags.deleteBodyInUse": "{count, plural, one {# unit carries it; it will have no tag.} other {# units carry it; they will have no tag.}}",
  "unitTags.usage": "{count, plural, one {# unit} other {# units}}",

  "sources.description": "Where your leads come from. Each lead and cold call is tagged with one.",
  "sources.placeholder": "New source, e.g. Property Finder",
  "sources.added": "Source added.",
  "sources.empty": "No sources yet",
  "sources.delete": "Delete {name}?",
  "sources.deleteBody": "Leads already tagged with it keep their history.",
  "sources.deleted": "Source deleted.",
  "campaigns.description": "The ads and pushes your leads come from, next to their source. Pick one on a lead or for a whole imported sheet.",
  "campaigns.placeholder": "New campaign, e.g. New Capital launch – October",
  "campaigns.added": "Campaign added.",
  "campaigns.empty": "No campaigns yet",
  "campaigns.delete": "Delete {name}?",
  "campaigns.deleteBody": "Its leads stay; they just lose the campaign.",
  "campaigns.deleted": "Campaign deleted.",
  "areas.description": "Where your leads want to buy. Pick one or more on each lead, then filter the list by area.",
  "areas.placeholder": "New area, e.g. North Coast",
  "areas.added": "Area added.",
  "areas.empty": "No areas yet",
  "areas.delete": "Delete {name}?",
  "areas.deleteBody": "Its leads stay; they just stop listing this area.",
  "areas.deleted": "Area deleted."
}
